import { useGetCreatingQuestionByIdQuery } from '@exam-management/graphql';
import { useEffect, useState } from 'react';

import type { Question } from '../../types';
import { useGetSingleQuestionWithImage } from '../use-get-single-question-with-image';

interface UseGetInDevelopmentSingleQuestionByIdProps {
  questionId: string;
  taskId: string;
}

export function useGetInDevelopmentSingleQuestionById(
  props: Readonly<UseGetInDevelopmentSingleQuestionByIdProps>,
) {
  const { questionId, taskId } = props;

  const [singleQuestion, setSingleQuestion] = useState<Question | null>(null);
  const [isSingleQuestionLoading, setIsSingleQuestionLoading] = useState(false);

  const { getSingleQuestionWithImage, loading: isGettingDownloadSignedUrlForQuestions } =
    useGetSingleQuestionWithImage({ questionId, taskId });

  const { loading: isLoading, error } = useGetCreatingQuestionByIdQuery({
    variables: {
      id: questionId,
      taskId,
    },
    onCompleted: (data) => {
      (async () => {
        const question = await getSingleQuestionWithImage(data.qctGetTaskQuestionById);

        setSingleQuestion(question);
        setIsSingleQuestionLoading(false);
      })();
    },
  });

  useEffect(() => {
    if (isLoading) {
      setIsSingleQuestionLoading(true);
    }
  }, [isLoading]);

  return {
    data: singleQuestion,
    error,
    loading: isLoading || isSingleQuestionLoading || isGettingDownloadSignedUrlForQuestions,
  };
}
